export enum DocumentType {
	Homepage = "homepage",
	Layout = "layout",
	ResourceCentre = "resource_centre",
	Post = "post",
	FAQ = "faq",
	Showcase = "showcase",
}
